import type { RelativeTimeLabels } from '@gasbi/shared/common/components/Chat/format';

/** The words of the shared `formatRelativeTime` («сьогодні, 14:02», «вчора», «08.10»). */
export const TIME_LABELS: RelativeTimeLabels = {
  justNow: 'щойно',
  today: 'сьогодні',
  yesterday: 'вчора',
};
